/** 农村人才 */
import { axios } from '@/utils/request'

export function TalentsInfoWebPage(parameter) {
  return axios({
    url: '/TalentsInfo/web/page',
    method: 'get',
    params: parameter
  })
}

export function TalentsInfoWebDetail(parameter) {
  return axios({
    url: '/TalentsInfo/web/detail',
    method: 'get',
    params: parameter
  })
}
/** 农村劳务 */
export function FarmerInfoWebDetail(parameter) {
  return axios({
    url: '/FarmerInfo/web/detail',
    method: 'get',
    params: parameter
  })
}
